import * as React from 'react';

export const FilePDFIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="35"
    height="45"
    viewBox="0 0 35 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <g opacity="0.3">
      <path
        opacity="0.3"
        d="M29.0979 10.2604C27.9589 10.2593 26.8669 9.80634 26.0615 9.00096C25.2562 8.19557 24.8032 7.10355 24.8021 5.96456V0H5.60627C2.51003 0 1.60933e-05 2.51 1.60933e-05 5.60623V39.4021C0.00461092 42.4932 2.5151 45 5.60627 45H28.6479C29.3843 45.0003 30.7292 45 30.7292 45H32.5C33.47 45 34.2563 44.2144 34.2563 43.2444C34.2563 41.7705 34.2563 39.8362 34.2563 39.3938V10.2521L29.0979 10.2604Z"
        fill="#F05252"
      />
    </g>
    <path
      d="M34.2566 10.2604H29.0983C27.9593 10.2593 26.8673 9.80634 26.0619 9.00096C25.2565 8.19557 24.8035 7.10355 24.8024 5.96456V0L34.2566 10.2604Z"
      fill="#F05252"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7181 15.6459V29.353C10.73 29.362 10.7547 29.3745 10.793 29.3745H23.3747C23.4131 29.3745 23.4378 29.362 23.4496 29.353V15.6459C23.4378 15.6369 23.4131 15.6245 23.3747 15.6245H10.793C10.7547 15.6245 10.73 15.6369 10.7181 15.6459ZM9.19037 15.6245C9.19037 14.715 9.97671 14.0967 10.793 14.0967H23.3747C24.1911 14.0967 24.9774 14.715 24.9774 15.6245V29.3745C24.9774 30.2839 24.1911 30.9022 23.3747 30.9022H10.793C9.97671 30.9022 9.19037 30.2839 9.19037 29.3745V15.6245ZM12.2459 17.9161C12.2459 17.4942 12.5879 17.1522 13.0098 17.1522H21.158C21.5799 17.1522 21.9219 17.4942 21.9219 17.9161C21.9219 18.338 21.5799 18.68 21.158 18.68H13.0098C12.5879 18.68 12.2459 18.338 12.2459 17.9161ZM12.2459 20.9717C12.2459 20.5498 12.5879 20.2078 13.0098 20.2078H21.158C21.5799 20.2078 21.9219 20.5498 21.9219 20.9717C21.9219 21.3936 21.5799 21.7356 21.158 21.7356H13.0098C12.5879 21.7356 12.2459 21.3936 12.2459 20.9717ZM12.2459 24.0272C12.2459 23.6054 12.5879 23.2633 13.0098 23.2633H17.5932C18.015 23.2633 18.3571 23.6054 18.3571 24.0272C18.3571 24.4491 18.015 24.7911 17.5932 24.7911H13.0098C12.5879 24.7911 12.2459 24.4491 12.2459 24.0272Z"
      fill="#F05252"
    />
    <rect
      x="6.98016"
      y="33.203"
      width="20.8333"
      height="7.62962"
      rx="1.5625"
      fill="#F05252"
    />
    <path
      d="M11.1735 39.1846C11.0423 39.1846 10.9296 39.1382 10.8354 39.0454C10.7426 38.9513 10.6962 38.8386 10.6962 38.7073C10.6962 38.5774 10.7426 38.4661 10.8354 38.3732C10.9296 38.2804 11.0423 38.234 11.1735 38.234C11.3008 38.234 11.4121 38.2804 11.5076 38.3732C11.603 38.4661 11.6508 38.5774 11.6508 38.7073C11.6508 38.7948 11.6282 38.875 11.5832 38.948C11.5394 39.0196 11.4817 39.0772 11.4101 39.121C11.3386 39.1634 11.2597 39.1846 11.1735 39.1846Z"
      fill="white"
    />
    <path
      d="M12.3762 39.1329V35.0602H13.983C14.2919 35.0602 14.5551 35.1192 14.7725 35.2372C14.9899 35.3538 15.1557 35.5162 15.2697 35.7244C15.385 35.9312 15.4427 36.1698 15.4427 36.4403C15.4427 36.7107 15.3844 36.9494 15.2677 37.1562C15.151 37.363 14.982 37.5241 14.7606 37.6394C14.5405 37.7548 14.274 37.8125 13.9612 37.8125H12.937V37.1224H13.8219C13.9877 37.1224 14.1242 37.0939 14.2316 37.0369C14.3403 36.9786 14.4212 36.8983 14.4742 36.7963C14.5286 36.6929 14.5558 36.5742 14.5558 36.4403C14.5558 36.3051 14.5286 36.1871 14.4742 36.0863C14.4212 35.9842 14.3403 35.9054 14.2316 35.8497C14.1229 35.7927 13.985 35.7642 13.818 35.7642H13.2373V39.1329H12.3762Z"
      fill="white"
    />
    <path
      d="M17.4597 39.1329H16.016V35.0602H17.4717C17.8813 35.0602 18.234 35.1417 18.5296 35.3048C18.8253 35.4665 19.0526 35.6992 19.2117 36.0028C19.3721 36.3064 19.4524 36.6697 19.4524 37.0926C19.4524 37.5168 19.3721 37.8814 19.2117 38.1863C19.0526 38.4912 18.8239 38.7252 18.5256 38.8883C18.2287 39.0514 17.8734 39.1329 17.4597 39.1329ZM16.8771 38.3951H17.4239C17.6785 38.3951 17.8926 38.35 18.0663 38.2599C18.2413 38.1684 18.3725 38.0272 18.46 37.8363C18.5488 37.6441 18.5933 37.3962 18.5933 37.0926C18.5933 36.7916 18.5488 36.5457 18.46 36.3548C18.3725 36.1639 18.2419 36.0233 18.0683 35.9332C17.8946 35.843 17.6805 35.798 17.4259 35.798H16.8771V38.3951Z"
      fill="white"
    />
    <path
      d="M20.1042 39.1329V35.0602H22.8008V35.7701H20.9653V36.7406H22.6218V37.4505H20.9653V39.1329H20.1042Z"
      fill="white"
    />
  </svg>
);

export default FilePDFIcon;
